import { render } from "./GuidePage.vue?vue&type=template&id=b7de6bea&ts=true"
import script from "./GuidePage.vue?vue&type=script&lang=ts"
export * from "./GuidePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__